export default __webpack_public_path__ + "static/media/Google-Play-Icon.e1329617.svg";